import moment from 'moment';
import React from 'react';

const SHORT_STAY = 3;
const MED_STAY = 7;
const LONG_STAY = 10;
const fixedStays = [SHORT_STAY, MED_STAY, LONG_STAY];

const CalendarActions = ({
    arrival,
    departure,
    nightsLabel,
    className,
    setDeparture,
    closeCalendar,
}) => (
    <div className={className}>
        {fixedStays.map((stay) => {
            const activeClass =
                moment.duration(arrival.diff(departure)).asDays() === stay
                    ? 'btn-active-selected'
                    : '';

            return (
                <button
                    key={stay}
                    className={`btn btn-active btn-border ${activeClass}`}
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setDeparture(moment(arrival).add(stay, 'd'));
                        closeCalendar();
                    }}
                    type="button"
                >
                    {stay} {nightsLabel}
                </button>
            );
        })}
    </div>
);

export default CalendarActions;
